import React from 'react';
import { Flex, SegmentedControl, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export type FilterValue = 'all' | 'active' | 'draft' | 'closed' | 'archived';

interface FilterBarProps {
  value: FilterValue;
  onChange: (v: FilterValue) => void;
  counts: Record<FilterValue, number>;
  search: string;
  onSearch: (s: string) => void;
  isMobile?: boolean;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  value,
  onChange,
  counts,
  search,
  onSearch,
  isMobile,
}) => {
  const { t } = useTranslation();
  const tabs: { v: FilterValue; label: string }[] = [
    { v: 'all', label: t('perfReview.adminHome.filter.all') },
    { v: 'active', label: t('perfReview.adminHome.filter.active') },
    { v: 'draft', label: t('perfReview.adminHome.filter.draft') },
    { v: 'closed', label: t('perfReview.adminHome.filter.closed') },
    { v: 'archived', label: t('perfReview.adminHome.filter.archived') },
  ];
  return (
    <Flex justify="space-between" align="center" gap="md" wrap="wrap">
      <SegmentedControl
        size="xs"
        fullWidth={isMobile}
        value={value}
        onChange={(v) => onChange(v as FilterValue)}
        data={tabs.map((tab) => ({
          value: tab.v,
          label: `${tab.label} · ${counts[tab.v]}`,
        }))}
        style={{ flex: isMobile ? '1 1 100%' : undefined }}
      />
      <TextInput
        placeholder={t('perfReview.adminHome.searchPlaceholder')}
        leftSection={<IconSearch size={14} />}
        value={search}
        onChange={(e) => onSearch(e.currentTarget.value)}
        size="sm"
        style={{ width: isMobile ? '100%' : 240, flex: isMobile ? '1 1 100%' : undefined }}
      />
    </Flex>
  );
};
